import { computed } from 'vue';
import getImageCropSettings from './getImageCropSettings';

const RATIO_EPSILON = 0.01;

const aspectRatio = ({ width, height }) => width / height;

const ratiosMatch = (a, b) => {
  if (a.type === 'free' && b.type === 'free') {
    return true;
  }

  return Math.abs(aspectRatio(a) - aspectRatio(b)) < RATIO_EPSILON;
};

const matchesAllRequiredCrops = (image, imageCropSettings) => {
  const imageCrops = getImageCropSettings(image.crops);

  return imageCropSettings.every(requiredCrop =>
    imageCrops.some(coverCrop =>
      coverCrop.type === requiredCrop.type &&
      ratiosMatch(coverCrop, requiredCrop)));
};

const useCropSettingsValidation = (cropSettings, lazyValue, options = {}) => computed(() => {
  const { allImages = false } = options;
  const imageCropSettings = getImageCropSettings(cropSettings.value);
  const images = lazyValue.value || [];

  if (allImages) {
    if (images.length === 0) {
      return true;
    }

    return images.every(image => image.crops != null && matchesAllRequiredCrops(image, imageCropSettings));
  }

  const coverImage = images.find(image => image.isSelected);

  if (coverImage?.crops) {
    return matchesAllRequiredCrops(coverImage, imageCropSettings);
  }

  return coverImage?.crops !== null;
});

export default useCropSettingsValidation;
